import React from 'react';
import { Row, Input } from "reactstrap";
import Button from "@material-ui/core/Button";
import { connect } from 'react-redux';
import { getFirstData, getSecondData, postAllData, postFirst, getAllData } from './FamilyLaw.actions';
import { useState, useEffect } from "react";
import { remove } from "lodash";


const FamilyLaw = (props) => {

    useEffect(() => {
        props.getFirstData();
        props.getSecondData();
        props.postFirst({divorce_id: window.localStorage.getItem("divorce_id")});
        props.getAllData({divorce_id: window.localStorage.getItem("divorce_id")});
    }, []);

    function clickFunction() {
        props.postAllData({

            divorce_id: window.localStorage.getItem("divorce_id"),
            fl130AppearanceRespondentId: Boxes,
            fl130AgreementStipulationWaiversId: Boxes2,
            fl130Other: getText(),
        });
    }
    const [Boxes, setBoxes] = useState([]);
    const [Boxes2, setBoxes2] = useState([]);

    function getCheckedValue(value) {
        if (Boxes.includes(value)) {
            let dummyArray = Boxes;
            remove(dummyArray, function (val) {
                return val === value;
            });
        } else {
            let dummyArray = Boxes;
           dummyArray.push(value);
            setBoxes(dummyArray[0]);
        }
    }

    function getSecondCheckedValue(value) {
        if (Boxes2.includes(value)) {
            let dummyArray = Boxes2;
            remove(dummyArray, function (val) {
                return val === value;
            });
        } else {
            let dummyArray = Boxes2;
            dummyArray.push(value);
            setBoxes2(dummyArray);
        }
    }

    function getText(value){
        return document.getElementById("text").value;

    }

    return (
        
        <div style={{ background: "white", height: "700px", paddingLeft: "20px", marginLeft: "10px" }}>
            <Row>
                <h1 style={{ fontSize: "23px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>1. Appearance by respondent (you must choose one):</h1>
            </Row>
            <form>
                <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                    <Input type="radio" id="1" name="radio" onChange={(e) => getCheckedValue(e.target.id)} ></Input>
                    <h6>By filling this form, I make a general appearance</h6>
                </Row>
                <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                    <Input type="radio" id="2" name="radio" onChange={(e) => getCheckedValue(e.target.id)} ></Input>
                    <h6>I have previously made a general appearance</h6>
                </Row>
                <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                    <Input type="radio" id="3" name="radio" onChange={(e) => getCheckedValue(e.target.id)}></Input>
                    <h6>I am a member of the military services of the United States of America. I have completed
                    and attached to this form Declaration and Conditional Waiver of Rights Under the Service members Civil Relief Act of 2003 (form FL-130(A))
                </h6>
                </Row>
            </form>
            <Row>
                <h1 style={{ fontSize: "23px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>2. Agreements, stipulations, and waivers (choose all that apply):</h1>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="1" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>The parties agree that this cause may be decided as an uncontested matter</h6>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="2" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>The parties waive their rights to notice of trial, a statement of decision,
                    a motion for new trial and the right to appeal </h6>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="3" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>This matter may be decided by a commissioner sitting as a temporary judge</h6>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="4" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>The parties have a written agreement that will be submitted to the court, or a stipulation
                    for judgement will be submitted to the court <br></br> and attached to Judgement (Family Law) (Form FL-180) </h6>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="5" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>None of these agreements or waivers will apply unless the court approves the stipulation for judgement
                or incorporates the written settlement agreement into judgement
                </h6>
            </Row>
            <Row style={{ paddingLeft: "30px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>
                <Input type="checkbox" id="6" onChange={(e) => getSecondCheckedValue(e.target.id)} />
                <h6>This is a perentage case, and both parties have signed an Advisement and Waiver of Rights Re: Determination
                of Parental Relationship (Form FL-235) or its equivalent
                </h6>
            </Row>
            <Row>
                <h1 style={{ fontSize: "23px", paddingTop: "10px", fontFamily: "notoserif", fontStyle: "italic" }}>3. Other (Specify):</h1>
            </Row>
            <Row style={{ paddingTop: "10px", paddingLeft: "10px", width: "900px" }}>
                <Input id="text" type="textarea" onBlur={(e) => getText(e.target.value)} />
            </Row>
            <Row style={{ paddingTop: "25px", paddingLeft: "15px" }}>
                <Button variant="contained" color="primary" id="submit" onClick={() => { clickFunction() }} >
                    Submit
            </Button>
            </Row>

        </div>
    )
}


const mapDispatchToProps = (dispatch) => {
    return {
        getFirstData: () => dispatch(getFirstData()),
        getSecondData: () => dispatch(getSecondData()),
        postAllData: (data) => dispatch(postAllData(data)),
        postFirst: (data) => dispatch(postFirst(data)),
        getAllData: () => dispatch(getAllData()),
    }
}

const mapStateToProps = (state, ownProps) => ({
    array: state.FamilyLawReducer.array,
    arraySecond: state.FamilyLawReducer.arraySecond,
    isGetAllData:  state.FamilyLawReducer.isGetAllData,

})

export default connect(mapStateToProps, mapDispatchToProps)(FamilyLaw);

